export const state = () => ({
  search: null,
  favorite: null,
  hidden: null,
  hasReset: false,
  pendingEmail: null,
  passwordExpired: false,
  hasRenewed: false,
})

export const mutations = {
  setSearch(state, payload) {
    state.search = payload
  },

  setFavorite(state, payload) {
    state.favorite = payload
  },

  setHidden(state, payload) {
    state.hidden = payload
  },

  setHasReset(state, payload) {
    state.hasReset = payload
  },

  setPendingEmail(state, payload) {
    state.pendingEmail = payload
  },

  setPasswordExpired(state, payload) {
    state.passwordExpired = payload
  },

  setHasRenewed(state, payload) {
    state.hasRenewed = payload
  },
}

export const actions = {
  setSearch({ commit }, search) {
    commit('setSearch', search)
  },

  setFavorite({ commit }, favorite) {
    commit('setFavorite', favorite)
  },

  setHidden({ commit }, hidden) {
    commit('setHidden', hidden)
  },

  setPendingEmail({ commit }, email) {
    commit('setPendingEmail', email)
  },

  setPasswordExpired({ commit }, expired) {
    commit('setPasswordExpired', expired)
  },

  setHasRenewed({ commit }, renewed) {
    commit('setHasRenewed', renewed)
  },
}
